import SpriteSymbol from "../../../../../doctor/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../doctor/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "IconMessagesBubble",
  "use": "IconMessagesBubble-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"IconMessagesBubble\"><path d=\"M16 1.783C7.545 1.783.667 7.449.667 14.415a11.466 11.466 0 004.233 8.72L1.833 29.25a.667.667 0 00.88.902l8.198-3.816a18.29 18.29 0 005.09.711c8.454 0 15.332-5.667 15.332-12.633 0-6.967-6.878-12.632-15.333-12.632z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol